/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Southern_AfricaInputs */

const bn_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষিণ আফ্রিকা`)
};

const de_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Südliches Afrika`)
};

const el_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νότια Αφρική`)
};

const en_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Southern Africa`)
};

const es_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África del Sur`)
};

const fr_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrique australe`)
};

const hi_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दक्षिणी अफ्रीका`)
};

const hu_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dél-Afrika`)
};

const id_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika Selatan`)
};

const it_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa meridionale`)
};

const ja_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南部アフリカ`)
};

const ko_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남부 아프리카`)
};

const nl_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuidelijk Afrika`)
};

const pl_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afryka Południowa`)
};

const pt_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África Austral`)
};

const ru_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Южная Африка`)
};

const sv_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Södra Afrika`)
};

const tr_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güney Afrika`)
};

const uk_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Південна Африка`)
};

const vi_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nam Phi`)
};

const zh_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南部非洲`)
};

const zh_hant_geo_label_southern_africa = /** @type {(inputs: Geo_Label_Southern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南部非洲`)
};

/**
* | output |
* | --- |
* | "Southern Africa" |
*
* @param {Geo_Label_Southern_AfricaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_southern_africa = /** @type {((inputs?: Geo_Label_Southern_AfricaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Southern_AfricaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_southern_africa(inputs)
	if (locale === "de") return de_geo_label_southern_africa(inputs)
	if (locale === "el") return el_geo_label_southern_africa(inputs)
	if (locale === "en") return en_geo_label_southern_africa(inputs)
	if (locale === "es") return es_geo_label_southern_africa(inputs)
	if (locale === "fr") return fr_geo_label_southern_africa(inputs)
	if (locale === "hi") return hi_geo_label_southern_africa(inputs)
	if (locale === "hu") return hu_geo_label_southern_africa(inputs)
	if (locale === "id") return id_geo_label_southern_africa(inputs)
	if (locale === "it") return it_geo_label_southern_africa(inputs)
	if (locale === "ja") return ja_geo_label_southern_africa(inputs)
	if (locale === "ko") return ko_geo_label_southern_africa(inputs)
	if (locale === "nl") return nl_geo_label_southern_africa(inputs)
	if (locale === "pl") return pl_geo_label_southern_africa(inputs)
	if (locale === "pt") return pt_geo_label_southern_africa(inputs)
	if (locale === "ru") return ru_geo_label_southern_africa(inputs)
	if (locale === "sv") return sv_geo_label_southern_africa(inputs)
	if (locale === "tr") return tr_geo_label_southern_africa(inputs)
	if (locale === "uk") return uk_geo_label_southern_africa(inputs)
	if (locale === "vi") return vi_geo_label_southern_africa(inputs)
	if (locale === "zh") return zh_geo_label_southern_africa(inputs)
	return zh_hant_geo_label_southern_africa(inputs)
});